<template>
  <div class="searchExam" v-loading="loading">
    <div class="top-title">{{msg.name}}无纸化全真模拟考试</div>
    <div class="contents">
      <div class="content">
        <div class="first-title">{{msg.name}}考试成绩查询</div>
        <div class="second-title">
          <span>姓名：{{uesrs.name}}</span>
          <span style="margin-left:40px">准考证号：{{msg.id}}</span>
        </div>
        <div>
          <el-table
            ref="multipleTable"
            :data="listTable"
            tooltip-effect="dark"
            style="margin-top: 20px; width: 700px;"
            border
          >
            <el-table-column align="center" show-overflow-tooltip prop="name" label="科目名称"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="score" label="成绩">
              <template slot-scope="scope">
                <span
                  :style="scope.row.score>=60?'color:#41D497':'color:#FC5E5E'"
                >{{scope.row.score}}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="type"
              label="题目解析"
              width="320"
            >
              <template slot-scope="scope">
                <el-button @click="getResult(scope.row,false)" size="small">查看解析</el-button>
                <el-button @click="getResult(scope.row,true)" size="small">查看错题</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="result-title" v-if="listTable[0].score>=60">恭喜你，通过本次考试</div>
        <div class="result-title" v-else>很遗憾，您未通过本次考试</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showVisible: false,
      loading: false,
      type: 1,
      msg: {
        examStudent: {
          exerciseId: ""
        }
      },
      listTable: [
        {
          score: 0,
          name: ""
        }
      ],
      wrongTrue: {
        correctNumberList: [],
        wrongNumberList: []
      }
    };
  },
  created() {},
  computed: {
    uesrs() {
      return this.$store.state.loginData;
    }
  },
  methods: {
    getResult(row, sty) {
      this.api.examStudent
        .simulateGetExamSettingInfo({
          examSettingId: this.$route.query.examSettingId
        })
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.type = res.data.showAnalysis;
            // this.getExerciseResultById();
            this.$router.push({
              path: "/getResult",
              query: {
                exerciseId: row.exerciseId,
                examSettingId: row.examSettingId,
                sty: sty
              }
            });
            // const { href } = this.$router.resolve({
            //   path: "/getResult",
            //   query: {
            //     exerciseId: row.exerciseId,
            //     examSettingId: row.examSettingId,
            //     sty: sty
            //   }
            // });
            // const a = document.createElement("a");
            // a.setAttribute("href", href);
            // a.setAttribute("target", "_blank");
            // a.setAttribute("id", "open");
            // document.body.appendChild(a);
            // a.click();
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getExamSettingInfo() {
      this.loading = true;
      this.api.examStudent
        .simulateGetExamSettingInfo({
          examSettingId: this.$route.query.examSettingId
        })
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.msg = res.data;
            this.type = this.msg.showAnalysis;
            this.loading = false;
            this.getExerciseResultById();
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getExerciseResultById() {
      this.loading = true;
      this.api.question
        .getExerciseResultById({
          exerciseId: this.$route.query.exerciseId
        })
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.wrongTrue.correctNumberList = res.correctNumberList;
            this.wrongTrue.wrongNumberList = res.wrongNumberList;
            localStorage.setItem("wrongTrue", JSON.stringify(this.wrongTrue));
            this.listTable = [
              {
                name: this.msg.subjectCourse.name,
                score: res.examScore,
                exerciseId: this.$route.query.exerciseId,
                examSettingId: this.$route.query.examSettingId
              }
            ];
          } else {
            this.$message.error(res.msg);
          }
        });
    }
  },
  watch: {},
  mounted() {
    this.getExamSettingInfo();
  }
};
</script>

<style lang="less" rel="stylesheet/less">
@import "../../../static/css/main.less";
.searchExam {
  display: flex;
  width: 1200px;
  margin: auto;
  height: 100%;
  flex-direction: column;
  background: #fff;
  border-radius: 6px;
  .top-title {
    font-family: "微软雅黑";
    font-weight: 400;
    font-style: normal;
    font-size: 24px;
    color: #455a64;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    padding: 25px;
  }
  .contents {
    padding: 0 100px 50px 100px;
    background: #fff;
    .content {
      background-color: rgb(246, 249, 250);
      padding: 50px;
      .center();
      flex-direction: column;
      .second-title {
        span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .first-title {
        font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
        font-weight: 400;
        font-style: normal;
        color: #455a64;
        text-align: center;
        line-height: 32px;
        padding: 20px 0;
        font-size: 24px;
      }
      .result-title {
        font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
        font-weight: 700;
        font-style: normal;
        font-size: 24px;
        color: #455a64;
        line-height: 24px;
        font-size: 20px;
        padding-top: 60px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/fullTruthModelTest/searchExam.vue